import { isVideoArticlePage } from '../../utils/aem-utils';
import { isWidthDeviceMobileTablet } from '../../utils/device-utils';
import { VIDEO_PLAYER_STATUS } from '../video-player/constants';
import logger from '../../services/logging/logging-service';

import {
  appendCloseButton,
  disableStickyElementAttributes,
  disableStickyElementDesktop,
  disableStickyElementMobile,
  getVideoPlayer,
  removeCloseButton,
} from './helpers';

export const initVideoPlayerListeners = (players, setHasUserRejectedSticky, hasUserRejectedSticky) => {
  const playerInstance = getVideoPlayer(players);
  if (!playerInstance) {
    return;
  }

  playerInstance.on(VIDEO_PLAYER_STATUS.COMPLETE, () => {
    setHasUserRejectedSticky(true);
    disableStickyElementAttributes(players);
    if (isWidthDeviceMobileTablet()) {
      disableStickyElementMobile(players);
    } else {
      disableStickyElementDesktop();
    }
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.PLAY, () => {
    if (!isVideoArticlePage() && !hasUserRejectedSticky) {
      appendCloseButton(players, setHasUserRejectedSticky);
    }
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.REPLAY_CLICK, () => {
    setHasUserRejectedSticky(false);
  });

  playerInstance.on(VIDEO_PLAYER_STATUS.PAUSE, () => {
    removeCloseButton();
  });
};
